import React from 'react';
import PropTypes from 'prop-types';
import DashboardSnapshotCard from './DashboardSnapshotCard';

const DashboardSnapshotCards = ({ cards }) => {
  if (!cards || !cards.length) {
    return null;
  }
  return (
    <div className="dashboard-snapshot-cards">
      {cards.map(row => (
        <DashboardSnapshotCard
          key={row.instrument.InstrumentId}
          instrument={row.instrument}
          product1={row.product1}
          level1Data={row.level1Data}
        />
      ))}
    </div>
  );
};

DashboardSnapshotCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      instrument: PropTypes.object.isRequired,
      product1: PropTypes.object.isRequired,
      level1Data: PropTypes.object.isRequired
    })
  )
};

DashboardSnapshotCards.defaultProps = {
  cards: []
};

export default DashboardSnapshotCards;
